import React from "react"
import "bootstrap/dist/css/bootstrap.min.css"
import "../../css/fonts.css"
import "../../css/main.css"
import "../../css/util.css"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import NavNavTop from "./Component/NavbarTop"
import NavNav from "./Component/Navbar"
import DetailsPage from "./Component/Details"
import Footer from "./Component/Footer"
import Helmet from "react-helmet"

class Details extends React.Component {
  render() {
    const [a, b] = this.props.location.search.split("+")
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>บริษัท แอ๊ดด้า ฟุตแวร์ (ไทยแลนด์) จำกัด</title>
        </Helmet>
        <NavNavTop />
        <NavNav />
        <div className="container">
          <DetailsPage ID={b} />
        </div>
        <Footer />
      </div>
    )
  }
}

export default Details
